import axios from "axios";
import authentication from "@/authentication";

export default {
  baseUrl: process.env.VUE_APP_API_FLIGHTS_SERVICE_BASE,
  async loadFlightMapData() {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/GetFlightMapData`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        if (typeof response.data === "string") return JSON.parse(response.data);
        else return response.data;
      });
  },
  async loadFlightsDetailData(updatedSinceUtc) {
    await authentication.isAuthenticated();
    return axios
      .get(
        `${this.baseUrl}/GetFlightsDetailData?updatedSinceUtc=${updatedSinceUtc}`,
        {
          headers: {
            Authorization: `Bearer ${authentication.getToken()}`
          }
        }
      )
      .then(response => {
        if (typeof response.data === "string") return JSON.parse(response.data);
        else return response.data;
      });
  },
  async loadDetailFlightData(flightId) {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/GetDetailFlightData?flightId=${flightId}`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return JSON.parse(response.data);
      });
  },
  async loadAirportsDetailData() {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/GetAirportsDetailData`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        if (typeof response.data === "string") return response.data;
        else return JSON.stringify(response.data);
      });
  }
};
